export default "__VITE_ASSET__58123250__"